import React from 'react';
export const HTML = ({tag, jsx}) => {
   
    return React.createElement(tag || 'div', { dangerouslySetInnerHTML: { __html: jsx } });
}